<template>
  <div class="TopCover-BottomTitle">
    <div class="item-container">
      <div
        v-for="(item,index) in cp_list"
        :key="index"
        class="item"
        @click="onClickItem(item)"
      >
        <div class="image">
          <web-img
            class="top-img"
            width="100%"
            height="100%"
            fit="cover"
            :src="item.imageUrl"
          />
        </div>
        <div class="bottom-content">
          <div class="title">
            {{ item.title }}
          </div>
          <div class="introduction">
            {{ item.content }}
          </div>
          <div class="time">
            {{ item.formatDate }}
          </div>
        </div>
      </div>
    </div>
    <seeMore
      v-if="list.length > 3"
      @click="goMore"
    />
  </div>
</template>

<script>
import webImg from '../webImg';
import seeMore from '../seeMore';
import { findRootNode, openUrl } from '../../../../../../lib/utils';

export default {
    name: 'TopCoverBottomTitle',
    components: {
        webImg, seeMore,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        rootId: {
            type: [String, Number],
            default: '',
        },
        list: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        cp_list () {
            let result = this.list;
            if (this.list.length > 3) {
                result = this.list.slice(0, 3);
            }
            return result.map(itm => {
                const date = new Date(itm.createTime);
                const year = date.getFullYear();
                let month = date.getMonth() + 1;
                let day = date.getDate();
                month = month < 10 ? '0' + month : month;
                day = day < 10 ? '0' + day : day;
                return Object.assign(itm, { formatDate: `${year}-${month}-${day}` });
            });
        },
        flatTreeList () {
            return this.$store.getters['system/getFlatTreeList'];
        },
        rootNode () {
            return findRootNode(this.flatTreeList, this.rootId);
        },
        catalogId () {
            const node = this.flatTreeList.find(itm => +itm.pCatalogId === this.rootNode.catalogId);
            if (node) return node.catalogId;
            return this.rootNode.catalogId;
        },
    },
    methods: {
        onClickItem (item) {
            const query = this.$route.query;
            const routeUrl = this.$router.resolve({
                path: '/webModulePage/articleDetail',
                query: {
                    catalogId: this.catalogId,
                    currCatalogId: item.catalogId,
                    contentId: item.contentId,
                    siteId: query.siteId,
                    preview: query.preview,
                    from: 'home',
                },
            });
            openUrl(routeUrl.href);
        },
        goMore () {
            const query = this.$route.query;
            const routeUrl = this.$router.resolve({
                path: '/webModulePage/articleList',
                query: {
                    catalogId: this.catalogId,
                    siteId: query.siteId,
                    preview: query.preview,
                    from: 'home',
                },
            });
            openUrl(routeUrl.href);
        },
    },
};
</script>

<style scoped lang="scss">
@import "../../style.scss";
.TopCover-BottomTitle {
    width: 100%;
    background-color: #F9F9F9;
    //padding-top: 30px;
    //padding-bottom: 30px;
    margin: 0;
    .item-container {
        width: $pageWidth;
        margin: 0 auto;
        box-sizing: border-box;
        display: flex;
        .item {
            width: 390px;
            height: 400px;
            padding: 20px;
            margin-right: 20px;
            box-sizing: border-box;
            border-radius: 4px;
            background-color: #FFFFFF;
            cursor: pointer;
            transition: box-shadow .3s;
            &:last-child {
                margin-right: 0;
            }
            &:hover {
                box-shadow: 0px 4px 10px 0px rgba(12, 17, 40, 0.1);
                .image .top-img {
                    transform: scale(1.1);
                }
            }
            .image {
                width: 350px;
                height: 200px;
                overflow: hidden;
                border-radius: 4px;
                margin-right: 20px;
                .top-img {
                    transition: transform .5s;
                }
            }
            .bottom-content {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                margin-top: 20px;
                height: 150px;
                width: 100%;
                .title {
                    width: 100%;
                    font-size: 18px;
                    color: #464C5B;
                    font-weight: 600;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    overflow: hidden;
                    -webkit-line-clamp: 2;
                    /*! autoprefixer: off */
                    -webkit-box-orient: vertical;
                    /* autoprefixer: on */
                    text-align: justify;
                    word-break: break-all;
                }
                .introduction {
                    width: 100%;
                    font-size: 16px;
                    color: #657180;
                    line-height: 24px;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    overflow: hidden;
                    -webkit-line-clamp: 2;
                    /*! autoprefixer: off */
                    -webkit-box-orient: vertical;
                    /* autoprefixer: on */
                    text-align: justify;
                    word-break: break-all;
                }
                .time {
                    font-size: 14px;
                    color: #C3CBD6;
                    width: 100%;
                    text-align: right;
                }
            }
        }
    }
}
</style>
